import React, { useEffect } from "react";
import "./experience.css";
import { BiCheck } from "react-icons/bi";

const production = [
  { name: "Game Production" },
  { name: "Technical Production" },
  { name: "Agile & Scrum" },
  { name: "Sprint Planning" },
  { name: "Roadmap Planning" },
  { name: "Stakeholder Management" },
  { name: "Jira" },
  { name: "Notion" },
];

const development = [
  { name: "Unity" },
  { name: "C#" },
  { name: "Photon Fusion" },
  { name: "Firebase" },
  { name: "REST APIs" },
  { name: "Git & GitHub" },
  { name: "Bitbucket" },
  { name: "CI/CD" },
];

const Experience = () => {
  useEffect(() => {
    const options = { threshold: 0.25 };

    const listObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const panel = entry.target;
        if (!panel) return;

        if (entry.isIntersecting) {
          panel.classList.add("revealed");
        } else {
          panel.classList.remove("revealed");
          // force reflow so animation can replay next time
          // eslint-disable-next-line no-unused-expressions
          void panel.offsetWidth;
        }
      });
    }, options);

    const panels = document.querySelectorAll(".experience__container > div");
    panels.forEach((p) => listObserver.observe(p));

    return () => {
      panels.forEach((p) => listObserver.unobserve(p));
    };
  }, []);

  return (
    <section id="skills">
      <h5>My Toolkit</h5>
      <h2>Technical Skills</h2>
      <div className="container experience__container">
        <div className="experience__language glass-panel">
          <h3>Production</h3>

          <div className="experinece__content">
            {production.map((skill, i) => (
              <article
                className="experience__details"
                key={skill.name}
                style={{ ["--i"]: i }}
              >
                <span className="point-icon">
                  <BiCheck />
                </span>
                <div>
                  <h4>{skill.name}</h4>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="experience__tools glass-panel">
          <h3>Development</h3>

          <div className="experinece__content">
            {development.map((skill, i) => (
              <article
                className="experience__details"
                key={skill.name}
                style={{ ["--i"]: i }}
              >
                <span className="point-icon">
                  <BiCheck />
                </span>
                <div>
                  <h4>{skill.name}</h4>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
